import { combineReducers } from 'redux'
import { peerReviewDashboardReducer } from './peerReviewAnalytics'

export * from './usePeerReviewAnalytics'

export const peerReviewModuleReducer = combineReducers({
  peerReviewDashboard: peerReviewDashboardReducer
})
